'use es6';

import { fromJS, List } from 'immutable';
import { buildDrilldownReport } from '../report';
import { SOCIAL_CHANNELS } from '../../../constants/dataTypes';
import { EQ, IN } from '../../../constants/operators';
const generateSocialChannelsDrilldown = (report, keys, options) => {
  const sortProperty = keys.get(-2);
  const filterValue = keys.get(-3);
  const drilldownConfig = report.get('config').set('dimensions', fromJS(['breakdown'])).set('sort', fromJS([{
    property: sortProperty,
    order: 'DESC'
  }])).updateIn(['filters', 'custom'], existingFilters => existingFilters.filter(f => f.property !== 'breakdownType' && f.property !== 'filters').concat(fromJS([{
    property: 'breakdownType',
    operator: EQ,
    value: 'channelKey'
  }, {
    property: 'filters',
    operator: IN,
    values: [filterValue]
  }])));
  return Promise.resolve(buildDrilldownReport(report, drilldownConfig, options));
};
export default {
  isSupported: report => {
    const filterProperties = report.getIn(['config', 'filters', 'custom'], List()).map(f => f.get('property'));
    return report.getIn(['config', 'dataType']) === SOCIAL_CHANNELS && !filterProperties.includes('breakdownType') && !filterProperties.includes('filters');
  },
  generate: generateSocialChannelsDrilldown
};